import React, { useState } from "react";
import AdminHeader from "../layout/AdminHeader";

const Dashboard = () => {
    const [loader, setLoader] = useState(false);
    const availBalance = localStorage.getItem("creditBalance");


    return (
        <>
            {loader && (
                <div className="mainPreloaderMain">
                    <div className="mainPreloader">
                        <div></div>
                        <div></div>
                        <div></div>
                        <div></div>
                        <div></div>
                        <div></div>
                        <div></div>
                        <div></div>
                    </div>
                </div>
            )}
            <AdminHeader name={"Dashboard"} />
            <div className="dashboard__content">
                <div className="container-fluid">
                    <div className="dashboard__customerViewMain">
                        <div className="row">
                            <div className="col-md-6">
                                <div className="dashboard__card dashboard__card--balance">
                                    <h4>Total Credit Balance</h4>
                                    <p>{availBalance || 0}</p>
                                </div>
                            </div>
                         
                            <div className="col-md-6">
                                <div className="dashboard__card dashboard__card--data">
                                    <h4>Total Send Email</h4>
                                    <p>{0}</p>
                                </div>
                            </div>
                        </div>
                        <div className="row">
                            <div className="col-md-6">
                                <div className="dashboard__card dashboard__card--email">
                                    <h4>Total Email</h4>
                                    <p>{ 0}</p>
                                </div>
                            </div>
                         
                            <div className="col-md-6">
                                <div className="dashboard__card dashboard__card--campaign">
                                    <h4>Number of Campaign</h4>
                                    <p>{0}</p>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </>
    );
};

export default Dashboard;
